import React, { useState } from 'react';
import {
    Box,
    Button,
    Grid,
    MenuItem,
    TextField,
    Typography,
    IconButton,
    Select,
    InputLabel,
    FormControl,
    Paper,
    Snackbar,
    Alert,
    CircularProgress,
    Chip,
    Divider,
    InputAdornment,
    Tooltip,
} from '@mui/material';
import { Add, Delete, AltRoute, Place, Flag, ArrowForward, Straighten, DirectionsCar, LocalGasStation, Save } from '@mui/icons-material';
import axios from 'axios';
import { useEffect } from 'react';
import { create_route_vehicles, travel_admin, travel_route, vehicle_with_fuels } from '../api/API';
import { AdminPage, SectionTitle, GREEN, LIGHT, primaryButtonSx, dashedButtonSx, subCardSx } from '../admin/AdminPageLayout';

// const vehicleOptions = [
//     {
//         id: 1,
//         name: 'มอเตอร์ไซค์',
//         typeCar: 'motorcy',
//         efficiency: 40,
//         fuelTypes: ['แก๊สโซฮอล์ 91', 'แก๊สโซฮอล์ 95', 'แก๊สโซฮอล์ E20'],
//     },
//     {
//         id: 2,
//         name: 'รถยนต์',
//         typeCar: 'car',
//         efficiency: 15,
//         fuelTypes: ['แก๊สโซฮอล์ 91', 'แก๊สโซฮอล์ 95', 'แก๊สโซฮอล์ E20'],
//     },
//     {
//         id: 3,
//         name: 'รถตู้',
//         typeCar: 'van',
//         efficiency: 10,
//         fuelTypes: ['ดีเซล B7', 'ดีเซล Premium'],
//     },
// ];

function MainAddRouteFrom() { // เพิ่มข้อมูลการเดินทางแบบใหม่
    const [formData, setFormData] = useState({
        tid: 0,
        origin: '',
        destination: '',
        distance_km: '',
        vehicles: [],
    });

    const [snack, setSnack] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [travel, setTravel] = useState([]); // 👉 ลิสต์ข้อมูลจาก API
    const [travelRoute, setTravelRoute] = useState([]); // 👉 ลิสต์ข้อมูลจาก API
    const [vehicleOptions, setvehicleOptions] = useState([]); // 👉 ลิสต์ข้อมูลจาก API
    const [selectedTravelses, setSelectedTravelses] = useState(""); // 👉 tid ที่ถูกเลือก
    const token = localStorage.getItem("token");
    const [isLoading, setIsLoading] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // "success" | "error" | "warning" | "info"
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleClose = () => setSnack((s) => ({ ...s, open: false }));

    useEffect(() => {
        loadTravelses();
        loadVehicleOptions();
    }, []);

    const handletravelsesChange = (event) => {
        const tid = event.target.value;
        setSelectedTravelses(tid); // ✅ เก็บค่า tid ที่เลือก
        console.log("🆔 tid ที่เลือก:", tid);
        setFormData({ ...formData, tid: tid || selectedTravelses })
        LoadTravelRoute(tid)
    };

    console.log("formData", formData);
    console.log("travelRoute", travelRoute);

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const loadTravelses = async () => {
        setIsLoading(true)
        try {
            const resTravel = await axios.get(travel_admin, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log("resTravel.data ", resTravel.data);
            
            setTravel(resTravel.data || []); // ตรวจสอบรูปแบบ data ด้วย (array?)
            console.log("✅ ดึงข้อมูลเส้นทางสำเร็จ:", resTravel.data);
            setIsLoading(false)

        } catch (error) {
            console.error("❌ ดึงข้อมูลอำเภอล้มเหลว:", error);
            setIsLoading(false)
        }
    };
    const loadVehicleOptions = async () => {
        setIsLoading(true)
        try {
            const resTravel = await axios.get(vehicle_with_fuels, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            setvehicleOptions(resTravel.data || []); // ตรวจสอบรูปแบบ data ด้วย (array?)
            console.log("✅ ดึงข้อมูลขนาดยานพาหนะสำเร็จ:", resTravel.data);
            setIsLoading(false)
        } catch (error) {
            console.error("❌ ดึงข้อมูลอำเภอล้มเหลว:", error);
            setIsLoading(false)
        }
    };

    const LoadTravelRoute = async (tid) => {
        const resTravelRoute = await axios.post(travel_route, { tid: tid }, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        console.log("resTravelRoute.data", resTravelRoute.data);

        setTravelRoute(resTravelRoute.data || []); // ตรวจสอบรูปแบบ data ด้วย (array?)
    }

    const handleVehicleChange = (index, key, value) => {
        const updatedVehicles = [...formData.vehicles];
        updatedVehicles[index][key] = value;
        setFormData({ ...formData, vehicles: updatedVehicles });
    };

    const handleAddVehicle = () => {
        setFormData({
            ...formData,
            vehicles: [...formData.vehicles, { name: '', efficiency: '', fuelTypes: [] }],
        });
    };

    const handleRemoveVehicle = (index) => {
        const updatedVehicles = formData.vehicles.filter((_, i) => i !== index);
        setFormData({ ...formData, vehicles: updatedVehicles });
    };

    const isFormDataValid = (data) => {
        console.log("data", data);

        if (!data.tid) {
            return false;
        }
        return true;
    };
    const handleSubmit = async () => {
        console.log("ข้อมูลที่ส่ง:", formData);

        // เริ่มโหลด
        setIsLoading(true);

        if (!isFormDataValid(formData)) {
            setSnack({
                open: true,
                message: "กรุณากรอกข้อมูลให้ครบทุกช่องก่อนส่ง",
                severity: "error",
            });
            setIsLoading(false); // ยกเลิกโหลดเมื่อข้อมูลไม่ครบ
            return;
        }

        try {
            const res = await axios.post(create_route_vehicles, formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },

                });
            console.log(res.data);
            setSnackbarMessage("✅ ข้อมูลถูกบันทึกเรียบร้อยแล้ว!");
            setSnackbarSeverity("success");
            // ✅ เคลียร์ฟอร์ม แต่เก็บ tid ไว้
            const selectedTid = formData.tid;
            setFormData({
                tid: selectedTid,
                origin: "",
                destination: "",
                distance_km: "",
                vehicles: [],
            });
        } catch (err) {
            console.error(err);
            setSnackbarMessage("❌ ไม่สามารถบันทึกข้อมูลได้");
            setSnackbarSeverity("error");
        } finally {
            // หยุดโหลดไม่ว่าจะสำเร็จหรือ fail
            setSnackbarOpen(true);
            setIsLoading(false);
        }
    };



    return (
        <>
            <AdminPage
                icon={<AltRoute fontSize="large" />}
                title="เพิ่มเส้นทางใหม่"
                subtitle="กำหนดต้นทาง ปลายทาง ระยะทาง และยานพาหนะ เพื่อใช้คำนวณ CO₂e"
                actions={
                    <Button
                        onClick={handleSubmit}
                        disabled={isLoading}
                        variant="contained"
                        size="large"
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <Save />}
                        sx={primaryButtonSx}
                    >
                        {isLoading ? "กำลังบันทึก..." : "บันทึกข้อมูล"}
                    </Button>
                }
            >
                <SectionTitle step={1} title="เลือกเส้นทาง" />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel id="travelses-select-label">เส้นทาง</InputLabel>
                            <Select
                                name="travelses-select"
                                labelId="travelses-select-label"
                                id="travelses-select"
                                value={selectedTravelses} // ✅ ใช้ค่าที่เลือก
                                label="เส้นทาง"
                                onChange={handletravelsesChange}
                                sx={{
                                    bgcolor: "white",
                                    borderRadius: 1,
                                }}
                            >
                                <MenuItem value="">
                                    <em>-- เลือกเส้นทาง --</em>
                                </MenuItem>
                                {travel?.map((d) => (
                                    <MenuItem key={d.tid} value={d.tid}>
                                        {d.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />
                <SectionTitle step={2} title="ต้นทาง – ปลายทาง" />
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm>
                        <FormControl fullWidth>
                            <InputLabel id="origin-select-label">ต้นทาง</InputLabel>
                            <Select
                                name="origin-select"
                                labelId="origin-select-label"
                                id="origin-select"
                                label="ต้นทาง"
                                fullWidth
                                startAdornment={<InputAdornment position="start"><Place sx={{ color: GREEN }} /></InputAdornment>}
                                value={formData.origin}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    console.log("เลือกแล้ว:", selectedValue);
                                    setFormData({ ...formData, origin: selectedValue });
                                }}
                            >
                                <MenuItem value="">
                                    <em>-- เลือกต้นทาง --</em>
                                </MenuItem>
                                {travelRoute?.map((d, index) => (
                                    <MenuItem key={`${d.tid}-${index}`} value={d.name}>
                                        {d.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item sm="auto" sx={{ display: { xs: "none", sm: "flex" }, justifyContent: "center" }}>
                        <ArrowForward sx={{ color: "text.disabled" }} />
                    </Grid>
                    <Grid item xs={12} sm>
                        <FormControl fullWidth>
                            <InputLabel id="destination-select-label">ปลายทาง</InputLabel>
                            <Select
                                name="destination-select"
                                labelId="destination-select-label"
                                id="destination-select"
                                label="ปลายทาง"
                                fullWidth
                                startAdornment={<InputAdornment position="start"><Flag sx={{ color: "#e53935" }} /></InputAdornment>}
                                value={formData.destination}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    console.log("เลือกแล้ว:", selectedValue);
                                    setFormData({ ...formData, destination: selectedValue });
                                }}
                            >
                                <MenuItem value="">
                                    <em>-- เลือกปลายทาง --</em>
                                </MenuItem>
                                {travelRoute?.map((d, index) => (
                                    <MenuItem key={`${d.tid}-${index}`} value={d.name}>
                                        {d.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="ระยะทาง (กิโลเมตร)"
                            fullWidth
                            type="number"
                            value={formData.distance_km}
                            onChange={(e) => setFormData({ ...formData, distance_km: parseFloat(e.target.value) })}
                            InputProps={{
                                startAdornment: <InputAdornment position="start"><Straighten sx={{ color: GREEN }} /></InputAdornment>,
                                endAdornment: <InputAdornment position="end">กม.</InputAdornment>,
                            }}
                        />
                    </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />
                <SectionTitle
                    step={3}
                    title="ยานพาหนะในเส้นทางนี้"
                    extra={formData.vehicles.length > 0 && (
                        <Chip size="small" label={`${formData.vehicles.length} คัน`} sx={{ bgcolor: LIGHT, color: GREEN, fontWeight: 600 }} />
                    )}
                />
                <Grid container spacing={2}>
                    {formData.vehicles.length === 0 && (
                        <Grid item xs={12}>
                            <Box sx={{ textAlign: "center", py: 3, color: "text.secondary", border: "1px dashed #c5e1a5", borderRadius: 3, bgcolor: "#fafdf7" }}>
                                <DirectionsCar sx={{ fontSize: 40, color: "#aed581" }} />
                                <Typography variant="body2">ยังไม่มียานพาหนะ กด “เพิ่มยานพาหนะ” ด้านล่าง</Typography>
                            </Box>
                        </Grid>
                    )}

                    {formData.vehicles.map((vehicle, index) => {
                        return (
                            <Grid item xs={12} key={index}>
                                <Paper variant="outlined" sx={subCardSx}>
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                        <DirectionsCar sx={{ color: GREEN, mr: 1 }} />
                                        <Typography fontWeight={600} sx={{ flexGrow: 1 }}>
                                            ยานพาหนะ #{index + 1}{vehicle.name ? ` · ${vehicle.name}` : ""}
                                        </Typography>
                                        <Tooltip title="ลบยานพาหนะนี้">
                                            <IconButton size="small" color="error" onClick={() => handleRemoveVehicle(index)}>
                                                <Delete fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel>ประเภท</InputLabel>
                                                <Select
                                                    value={vehicle.name}
                                                    label="ประเภท"
                                                    sx={{ bgcolor: "white" }}
                                                    onChange={(e) => {
                                                        const selected = vehicleOptions.find((v) => v.name === e.target.value);
                                                        handleVehicleChange(index, 'name', selected.name);
                                                        handleVehicleChange(index, 'efficiency', selected.efficiency);
                                                        handleVehicleChange(index, 'fuelTypes', selected.fuelTypes);
                                                        handleVehicleChange(index, 'typeCar', selected.typeCar); // ✅ เก็บ typeCar
                                                        handleVehicleChange(index, 'fid', selected.id);          // ✅ เก็บ id ลงใน fid
                                                    }}
                                                >
                                                    {vehicleOptions.map((option) => (
                                                        <MenuItem key={option.name} value={option.name}>
                                                            {option.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="อัตราสิ้นเปลือง"
                                                type="number"
                                                fullWidth
                                                sx={{ bgcolor: "white" }}
                                                InputProps={{ endAdornment: <InputAdornment position="end">กม./ลิตร</InputAdornment> }}
                                                value={vehicle.efficiency}
                                                onChange={(e) =>
                                                    handleVehicleChange(index, 'efficiency', parseFloat(e.target.value))
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel>น้ำมันที่ใช้</InputLabel>
                                                <Select
                                                    multiple
                                                    label="น้ำมันที่ใช้"
                                                    sx={{ bgcolor: "white" }}
                                                    startAdornment={<InputAdornment position="start"><LocalGasStation sx={{ color: GREEN }} /></InputAdornment>}
                                                    renderValue={(selected) => (
                                                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                                            {selected.map((f) => <Chip key={f} label={f} size="small" sx={{ bgcolor: LIGHT, color: GREEN }} />)}
                                                        </Box>
                                                    )}
                                                    value={vehicle.fuelTypes}
                                                    onChange={(e) =>
                                                        handleVehicleChange(index, 'fuelTypes', e.target.value)
                                                    }
                                                >
                                                    {[
                                                        'แก๊สโซฮอล์ 91',
                                                        'แก๊สโซฮอล์ 95',
                                                        'แก๊สโซฮอล์ E20',
                                                        'ดีเซล B7',
                                                        'ดีเซล Premium',
                                                    ].map((fuel) => (
                                                        <MenuItem key={fuel} value={fuel}>
                                                            {fuel}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        )
                    })}

                    <Grid item xs={12}>
                        <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<Add />}
                            onClick={handleAddVehicle}
                            sx={dashedButtonSx}
                        >
                            เพิ่มยานพาหนะ
                        </Button>
                    </Grid>
                </Grid>
            </AdminPage>
            <Snackbar
                open={snack.open}
                autoHideDuration={4000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleClose}
                    severity={snack.severity}
                    sx={{ width: "100%" }}
                >
                    {snack.message}
                </Alert>
            </Snackbar>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </>
    );
}

export default MainAddRouteFrom